import angular from 'angular';

import * as Configuration from '../../../app.constants.js';
import { isActive } from './navigationUtils.js';

NavigationParametersController.$inject = [
  'company',
  'loggedUser',
  '$scope',
  'SiteFilterHelperFactory',
  '$stateParams',
  '$state',
  'LocalStorageFactory',
  'sites',
  'TopToolbarFactory',
];
export function NavigationParametersController(
  company,
  loggedUser,
  $scope,
  SiteFilterHelperFactory,
  $stateParams,
  $state,
  LocalStorageFactory,
  sites,
  TopToolbarFactory,
) {
  $scope.onItemSelected = onItemSelected;
  $scope.siteSelected = siteSelected;

  init();

  function onItemSelected(selectedItem) {
    deselectAllItems();
    selectedItem.isSelected = true;
  }

  function deselectAllItems() {
    $scope.companyParametersMenu.forEach(item => (item.isSelected = false));
  }

  function siteSelected(item) {
    updateSelectedSite(item.id);

    // if we are curently displaying a state that has a site param, let's switch site
    if ($state.params.siteId) {
      let params = {
        companyId: $state.params.companyId,
        siteId: item.id,
      };
      $state.go('.', params);
    }
  }

  function updateSelectedSite(selectedSiteId) {
    LocalStorageFactory.setItem('siteIdOfLastVisitedAccountParameters', selectedSiteId);
    $scope.siteMenu.forEach(s => (s.isSelected = false));
    let selectedSiteArray = $scope.siteMenu.filter(s => s.id === selectedSiteId);
    // If for some reason no site is found (perhaps the user typed an URL for a site that doesn't exist anymore),
    // let's select the first site instead of crashing
    if (selectedSiteArray.length === 0) {
      selectedSiteArray.push($scope.siteMenu[0]);
    }
    let selectedSite = selectedSiteArray[0]; // the filter left at most one item
    selectedSite.isSelected = true;
    $scope.selectedSite = selectedSite;
  }

  function init() {
    TopToolbarFactory.setSubNavBurger($scope);
    $scope.company = company;
    initCompanyParametersMenu();
    initSitesMenu();
    if ($scope.siteMenu.length > 0) {
      initSelectedSite(); // needs the site menu in case we default to the first site in the list
    }
  }

  function initSelectedSite() {
    // If we are currently displaying a site parameter page, let's select the current site in the list
    // If not, let's select the last site for which the user visited a site parameters page.
    // If none, let's select the first site in the list
    let selectedSiteId = Number($state.params.siteId); // Number(undefined) returns NaN which is falsy
    if (!selectedSiteId) {
      selectedSiteId = LocalStorageFactory.getItem('siteIdOfLastVisitedAccountParameters');
    }
    if (!selectedSiteId) {
      selectedSiteId = $scope.siteMenu[0].id;
    }
    updateSelectedSite(selectedSiteId);
  }

  function initSitesMenu() {
    if (loggedUser.is_company_admin) {
      $scope.siteMenu = angular.copy(sites);
    } else {
      $scope.siteMenu = []; // no 'by-account' param page is accessible to non-company-admin users
    }
    SiteFilterHelperFactory.addSortKeysAndSort($scope.siteMenu);
  }

  function v3BaseUrlPrefix() {
    return Configuration.constants.frontendBaseUrl + '#/';
  }

  function initCompanyParametersMenu() {
    let v3BaseUrl = v3BaseUrlPrefix();
    $scope.companyParametersMenu = [];
    if (loggedUser.is_company_admin) {
      $scope.companyParametersMenu.push(
        // First block
        {
          key: 'accounts',
          isSelected: isActive($state, 'parameters.accounts'),
          url: v3BaseUrl + $stateParams.companyId + '/fuse/parameters/accounts',
        },
        {
          key: 'users',
          isSelected: isActive($state, 'fuse.users-roles'),
          url: v3BaseUrl + $stateParams.companyId + '/fuse/users-roles',
        },
        {
          key: 'catalogs',
          isSelected: isActive($state, 'parameters.catalogs'),
          url: v3BaseUrl + $stateParams.companyId + '/fuse/parameters/catalogs',
        },
        {
          key: 'business-hours',
          isSelected: isActive($state, 'fuse.parameters.business-hours'),
          url: v3BaseUrl + $stateParams.companyId + '/fuse/parameters/business-hours',
        },
        {
          key: 'tags-groups',
          isSelected: isActive($state, 'parameters.tags-groups'),
          url: v3BaseUrl + $stateParams.companyId + '/parameters/tags-groups',
        },
        {
          key: 'order-of-messages',
          isSelected: isActive($state, 'fuse.parameters.priority-rules'),
          url: v3BaseUrl + $stateParams.companyId + '/fuse/parameters/priority-rules',
        },
        {
          key: 'company-contacts',
          isSelected: isActive($state, 'fuse.parameters.company-contacts'),
          url: v3BaseUrl + $stateParams.companyId + '/fuse/parameters/company-contacts',
        },
        {
          key: 'custom-events',
          isSelected: isActive($state, 'fuse.parameters.custom-events'),
          url: `${v3BaseUrl}${$stateParams.companyId}/fuse/parameters/custom-events`,
        },
        {
          key: 'track-link-labels',
          isSelected: isActive($state, 'fuse.parameters.track-link-labels'),
          url: `${v3BaseUrl}${$stateParams.companyId}/fuse/parameters/track-link-labels`,
        },
        {
          key: 'message-templates',
          isSelected:
            isActive($state, 'fuse.parameters.message-templates'),
          url: `${v3BaseUrl}${$stateParams.companyId}/fuse/parameters/message-templates`,
          isLastInCategory: true,
        },
        // Second block
        {
          key: 'links',
          isSelected: isActive($state, 'fuse.parameters.all-accounts.links'),
          url: v3BaseUrl + $stateParams.companyId + '/fuse/parameters/all-accounts/links',
        },
        {
          key: 'sessions',
          isSelected: isActive($state, 'parameters.sessions'),
          url: v3BaseUrl + $stateParams.companyId + '/parameters/sessions',
        },
        {
          key: 'sftp-servers',
          isSelected: isActive($state, 'parameters.sftp-servers'),
          url: v3BaseUrl + $stateParams.companyId + '/fuse/parameters/sftp-servers',
        },
        {
          key: 'exports',
          isSelected: isActive($state, 'parameters.sftp-exports'),
          url: v3BaseUrl + $stateParams.companyId + '/fuse/parameters/sftp-exports',
        },
        {
          key: 'applications',
          isSelected: isActive($state, 'parameters.applications'),
          url: v3BaseUrl + $stateParams.companyId + '/fuse/parameters/applications',
        },
        {
          key: 'external-authorizations',
          isSelected: isActive($state, 'parameters.external-authorizations'),
          url: v3BaseUrl + $stateParams.companyId + '/fuse/parameters/external-authorizations',
        },
        {
          key: 'alcmeon-ai',
          isSelected: isActive($state, 'parameters.alcmeon-ai'),
          url: v3BaseUrl + $stateParams.companyId + '/fuse/parameters/alcmeon-ai',
          isLastInCategory: true,
        },
        // CRM
        {
          key: 'salesforce-organizations',
          isSelected: isActive($state, 'parameters.crm.organizations') && $state.params.crmType === 'salesforce',
          url: v3BaseUrl + $stateParams.companyId + '/fuse/parameters/crm/salesforce/organizations',
        },
        {
          key: 'zendesk-organizations',
          isSelected: isActive($state, 'parameters.crm.organizations') && $state.params.crmType === 'zendesk',
          url: v3BaseUrl + $stateParams.companyId + '/fuse/parameters/crm/zendesk/organizations',
        }
      );
      $scope.companyParametersMenu.push(
        // custom-field
        {
          key: 'custom-field',
          isSelected: isActive($state, 'parameters.custom-field') && $state.params.requestedPage === 'home',
          url: v3BaseUrl + $stateParams.companyId + '/fuse/parameters/custom-field?requestedPage=home',
        }
      );
    }
  }
}
